import{useCoreContext as o}from"./CoreProvider.js";import{useCallback as r}from"../../external/preact/hooks/dist/hooks.js";function e(){const{resources:e}=o();return r((o=>null==e?void 0:e.getImage(o)),[])}export{e as default};
//# sourceMappingURL=useImage.js.map
